import { styled } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import groovColors from "../../styles/colors";

const StyledHelpOutlineIcon = styled(HelpOutlineIcon)({
  color: groovColors.neutral[40],
  cursor: "pointer",
});
export default StyledHelpOutlineIcon;
